import { render, staticRenderFns } from "./youtube.vue?vue&type=template&id=c2b9e8fe&scoped=true"
import script from "./youtube.vue?vue&type=script&lang=js"
export * from "./youtube.vue?vue&type=script&lang=js"
import style0 from "./youtube.vue?vue&type=style&index=0&id=c2b9e8fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b9e8fe",
  null
  
)

export default component.exports